import Vue from 'vue';
import trans from './trans.js';

Vue.filter('moment', (date) => {
  return moment(date).format('DD.MM.YYYY H:mm:ss');
})

Vue.filter('trans', (data) => {
  return trans(data);
})

Vue.mixin({
  methods: {
    trans(data) {
      return trans(data);
    }
  }
});
